module.exports = __webpack_public_path__ + "static/indicate_logo_PR-694c12ea8455c946ca64a3f4eb8cbe7f.png";